export default __webpack_public_path__ + "static/media/application-img-06.7375b926.jpg";